import { _ as _root } from './_root.js';
import './_baseGetTag.js';
import './_baseToString.js';

var root = _root;

/* Built-in method references for those with the same name as other `lodash` methods. */
root.isFinite;
